import urljoin from 'url-join';
import WSConnection from './WSConnection';

class AdminWebsocket extends WSConnection {
	connect(uri) {
		// replace scheme with ws://
		const origin = window.location.origin.replace(/^http(s)?:\/\//, 'ws://');
		return super.connect(urljoin(origin, window.$conf.apiprefix, uri));
	}
}

export default AdminWebsocket;
